(() => {
  if (window.__adsCakesCollectionReady) return;
  window.__adsCakesCollectionReady = true;

  const syncVisibleCount = (root) => {
    if (!root?.classList?.contains('cakes-commerce')) return;
    const activeCount = Number(root.dataset.activeFilterCount || 0);
    const resultCount = Number(root.dataset.resultCount || 0);
    const label = activeCount > 0 ? `${resultCount} ${resultCount === 1 ? 'cake' : 'cakes'}` : '200+ cakes';
    root.querySelectorAll('.collection-tools__count, .collection-tools__mobile-count')
      .forEach((node) => { node.textContent = label; });
  };

  document.querySelectorAll('storefront-filters.cakes-commerce').forEach(syncVisibleCount);

  document.addEventListener('ads:filter_apply', (event) => {
    const root = event.target?.closest?.('storefront-filters.cakes-commerce');
    syncVisibleCount(root);
  });

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-cakes-load-more]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const root = link.closest('storefront-filters.cakes-commerce');
    const list = root?.querySelector('[data-cakes-product-list]');
    const status = root?.querySelector('[data-cakes-load-status]');
    if (!root || !list || link.dataset.loading === 'true') return;

    event.preventDefault();
    const fallbackUrl = link.href;
    const originalText = link.textContent;
    link.dataset.loading = 'true';
    link.setAttribute('aria-disabled', 'true');
    link.textContent = 'Loading…';
    root.setAttribute('aria-busy', 'true');

    try {
      const requestUrl = new URL(fallbackUrl, window.location.origin);
      requestUrl.searchParams.set('section_id', root.dataset.sectionId);
      const response = await fetch(requestUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error(`Cakes collection request failed: ${response.status}`);

      const markup = await response.text();
      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const replacement = doc.querySelector('storefront-filters.cakes-commerce');
      const replacementList = replacement?.querySelector('[data-cakes-product-list]');
      if (!replacement || !replacementList) throw new Error('Cakes collection response was incomplete.');

      const items = [...replacementList.children];
      items.forEach((item) => list.append(document.importNode(item, true)));

      const nextLink = replacement.querySelector('[data-cakes-load-more]');
      const pagination = link.closest('[data-cakes-pagination]');
      if (nextLink) {
        link.href = nextLink.href;
        link.textContent = originalText;
        link.dataset.loading = 'false';
        link.removeAttribute('aria-disabled');
      } else {
        pagination?.remove();
      }

      if (status) status.textContent = `${items.length} more cakes loaded.`;
    } catch (error) {
      window.location.assign(fallbackUrl);
      return;
    } finally {
      root.removeAttribute('aria-busy');
      if (document.body.contains(link) && link.dataset.loading === 'true') {
        link.dataset.loading = 'false';
        link.removeAttribute('aria-disabled');
        link.textContent = originalText;
      }
    }
  });
})();